import React from 'react';

export default function FormFieldLabel({ schema, name, htmlFor = name, children, className }) {
  const field = schema.field(name);
  return (
    <label htmlFor={htmlFor} className={className}>
      {field.label}
      {field.required ? ' *' : ''}
      {children}
    </label>
  );
}
